import { create } from 'zustand';

interface SubscriptionState {
  daysLeft: number | null;
  blocked: boolean;
  setDaysLeft: (d: number | null) => void;
  setBlocked: (b: boolean) => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set) => ({
  daysLeft: null,
  blocked: false,
  setDaysLeft: (daysLeft) => set({ daysLeft }),
  setBlocked: (blocked) => set({ blocked }),
}));
